module.exports = __webpack_public_path__ + "img/person-old.3a761bdc.svg";